module.exports = __webpack_public_path__ + "static/media/sticklersparadiseimage.e95a31ce.jpg";